import {
  UtcDate,
  DATE_FORMAT,
} from '@/helpers/date';
// TODO - used on convictedriver, claims & convictions (core products). Could be replaced by decomposing to required & before/after rules
export default {
  computesRequired: true,
  params: ['itemType'],
  validate (value) {
    if (!value) {
      return {
        valid: false,
        required: true,
      };
    }

    const dateOfIncidentUtc = new UtcDate(value);
    const todayUtc = new UtcDate();

    if (!new UtcDate().parse(value, DATE_FORMAT).isValid() ||
      dateOfIncidentUtc.isBefore(todayUtc.subYears(this.constants.INCIDENT_MAX_YEARS))
    ) {
      return {
        valid: false,
        required: true,
      };
    }

    return {
      valid: true,
      required: true,
    };
  },
  message (fieldName, { _value_: v, itemType }) {
    const defaultMsg = 'Please enter the date.';
    if (!v) return defaultMsg;
    const dateOfIncidentUtc = new UtcDate(v);
    const todayUtc = new UtcDate();
    if (!new UtcDate().parse(v, DATE_FORMAT).isValid()) return `Invalid format for the date of the ${itemType}.`;
    if (dateOfIncidentUtc.isBefore(todayUtc.subYears(this.constants.INCIDENT_MAX_YEARS))) return `The ${itemType} must be within the last five years.`;
    return defaultMsg;
  },
};
